import React, { useState , useEffect } from "react";
import BannerWrapper from "../../component/Banner_Wrapper";
import BYP_Transiton_Card from "../../component/BYP_Transition_Card";
import { useIsMobile } from "../../Hooks/useIsMobile";
import {useSelector}  from "react-redux"
import {
  PrimeSenior,
  SuperTopup,
  ProHealth,
  Lifetime,
  PrimeProhealth,
  CI,
  PA,
  Ring,
} from "../../assets/index";
import { typeOfCal} from "../../Constant";
import axios from "axios";
import { intersubcatSelected } from "../../Redux/IntermediaryReducer";
import { getApi } from "../../service/ApiService";
import MessageAlert from "../../component/popUpComponent";

const Home = () => {
  const [paramsData, setParamsData] = useState();
  const [showLoader, setShowLoader] = useState(false);
  const [parentagencyid, setParentAgencyId] = useState("");
  const isMobile = useIsMobile();
  const typeOfCalculator = useSelector((s) => s.common.type);
  const agentDataSelected = useSelector((state) => state.agData.agentData);
  const intersubcatSelected = useSelector((state) => state.agData.loginData);

  const [filterProduct, setProduct] = useState([8, 1, 2, 4]);
  
  const [data, setData] = useState([
     {
      type: typeOfCal.mchiSarvah,
      label: "Sarvah",
      image: Ring,
      id: 8,
      subMenuClicked: false,
    }, 
    {
      type: typeOfCal.lifetime,
      label: "Lifetime Health",
      image: Lifetime,
      id: 0,
      subMenuClicked: false,
    },
    {
      type: typeOfCal.prohealthPrime,
      label: "ProHealth Prime",
      image: PrimeProhealth,
      id: 1,
      subMenuClicked: false,
    },
    {
      type: typeOfCal.primeSenior,
      label: "Prime Senior",
      image: PrimeSenior,
      id: 2,
      subMenuClicked: false,
    },
    /* {
      type: typeOfCal.prohealth,
      label: "ProHealth",
      image: ProHealth,
      id: 3,
      subMenuClicked: false,
    }, */
    {
      type: typeOfCal.superTopUp,
      label: "Super Top Up",
      image: SuperTopup,
      id: 4,
      subMenuClicked: false,
    },
    {
      type: typeOfCal.ci,
      label: "Critical Illness",
      image: CI,
      id: 5,
      subMenuClicked: false,
    },
    {
      type: typeOfCal.pa,
      label: "Personal Accident",
      image: PA,
      id: 6,
      subMenuClicked: false,
    },
    {
      type: typeOfCal.accident_Shield,
      label: "Accident Shield",
      image: PA,
      id: 7,
      subMenuClicked: false,
    },
  ]);

  useEffect(() => {
    getQuery();
    productSetup();
    pospApiCall();
  }, []);
  const getQuery = () => {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    //env key
    var key = "lv39eptlvuhaqqer";
    if (params) {
      var parentagencyid = params.get("parentagencyid");
      if (parentagencyid !== null) {
        getPortalDetails(parentagencyid);
      }
    }
  };

  const pospApiCall = async () => {

    // try {
    //     const res = await getApi(`${process.env.REACT_APP_Base_Url}intermediary/v1/getpospdetails`)
    //     console.table(res)
    // } catch (err) {
    //       console.error(err)
    // }

  }

  const getPortalDetails = (parentagencyid) => {
    setShowLoader(true);
    var config = {
      method: "post",
      url: process.env.REACT_APP_Sell_Url  + "getDistributionPortalDetails?parentAgencyId=" + parentagencyid,
      headers: {
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function (response) {
        let arr=[];
        if(response.data.response){
          response.data.response.forEach(element => {
            let obj = {
              type: typeOfCal + "." + element.productName,
              label: element.productName,
              image: element.productName,
              id: 2,
              subMenuClicked: false,
            }
            arr.push(obj);
          });
       setData(arr);
        }
        setShowLoader(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const productSetup= () => {
    setProduct([8, 1, 2, 4]);//posp case product display
    if(agentDataSelected.parentagencyid==process.env.REACT_APP_BLUECHIP_PARENT_AGENT_ID){
      setProduct([8,0,1,2]);// blue chip partner product display
    }
  }

  return (
    <div>
      <BannerWrapper>
        <>
          {/* {agentDataSelected.agentId ==="" &&  agentDataSelected.agentName ==="" ? (
            <MessageAlert 
              isModalOpen ={true}
              message='No Data Present'
            />
          )
        : */}
        <div
          className="row align-items-start container gy-3"
          style={{ marginTop: `${isMobile ? "14px" : "14px"}` }}
        >
          {intersubcatSelected.intermedsubcatcd == "POSP" || agentDataSelected.parentagencyid== process.env.REACT_APP_BLUECHIP_PARENT_AGENT_ID ? 
          data.filter(ei => filterProduct.includes(ei.id)).map((ei, i) => ( //[8, 1, 2, 4]
            <>
              <div className="col-md-3">
                <BYP_Transiton_Card
                  key={`card-${ei.id}`}
                  data={ei}
                  onSubmenuChange={() => {
                    const newArr = [...data];
                    newArr[i].subMenuClicked = !data[i].subMenuClicked;
                    setData(newArr);
                  }}
                />
              </div>
            </>
          )) : agentDataSelected?.businesscreditchannel === "325" ? 
          data.filter(ei => ![3].includes(ei.id)).map((ei, i) => (
            <>
              <div className="col-md-3">
                <BYP_Transiton_Card
                  key={`card-${ei.id}`}
                  data={ei}
                  onSubmenuChange={() => {
                    const newArr = [...data];
                    newArr[i].subMenuClicked = !data[i].subMenuClicked;
                    setData(newArr);
                  }}
                />
              </div>
            </>
          ))
            :
            data.map((ei, i) => (
              <>
                <div className="col-md-3">
                  <BYP_Transiton_Card
                    key={`card-${ei.id}`}
                    data={ei}
                    onSubmenuChange={() => {
                      const newArr = [...data];
                      newArr[i].subMenuClicked = !data[i].subMenuClicked;
                      setData(newArr);
                    }}
                  />
                </div>
              </>
            ))
          }
        </div>
        
        </>
      </BannerWrapper>
    </div>
  );
};

export default Home;
